// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellModal-cls1_z_T","cls2":"TasteOfMentionsUpsellModal-cls2_gXO TasteOfMentionsUpsellModal-cls1_z_T"};